import clsx from 'clsx';
import { useSelector } from 'react-redux';
import { ThemeProvider, useTheme } from '@mui/material';
import FuseScrollbars from '@fuse/core/FuseScrollbars';

import { selectContrastMainTheme } from 'app/store/fuse/settingsSlice';

export interface FusePageSimpleSidebarContentProps {
	variant?: string;
	header?: React.ReactNode;
	content?: React.ReactNode;
	innerScroll?: boolean;
}

function FusePageSimpleSidebarContent(props: FusePageSimpleSidebarContentProps) {
	const theme = useTheme();
	const contrastTheme = useSelector(selectContrastMainTheme(theme.palette.primary.main));

	return (
		<FuseScrollbars enable={props.innerScroll}>
			<>
				{props.header && (
					<ThemeProvider theme={contrastTheme}>
						<div className={clsx('FusePageSimple-sidebarHeader', props.variant)}>{props.header}</div>
					</ThemeProvider>
				)}
				{props.content && <div className="FusePageSimple-sidebarContent">{props.content}</div>}
			</>
		</FuseScrollbars>
	);
}

export default FusePageSimpleSidebarContent;
